import {observer} from 'mobx-react';
import React from 'react';
import {X9Content, X9ContentSnapshot} from '../../../../../../domain';
import {ReactNodeGenerator} from '../../../../../../lib/helpers';
import {X9ContentStateStore} from '../../../common/X9ContentStateStore';
import {SyncedVideoModel} from '../../models';
import {VideoElementStore} from '../common/VideoElementStore';
import {VideoProgress} from '../common/VideoProgress';
import {TeacherSyncedVideoStore} from './TeacherSyncedVideoStore';

interface Props {
  x9: X9Content | X9ContentSnapshot,
  store: X9ContentStateStore
}

function* trackedStudentProgress(store: TeacherSyncedVideoStore): ReactNodeGenerator {
  yield <VideoProgress className="student-progress" store={store.progress}
                       updateVideo={store.video}/>
  // let lastKey = Array.from(store.trackedStudents.entries()).pop();

  // if (lastKey) {
  //   let [clientId, progressStore] = lastKey;

  //   yield (<VideoProgress key={clientId}
  //                         store={progressStore}
  //                         className="student-progress"/>);
  // }
}

@observer
class TeacherPlayButton extends React.Component<{ store: VideoElementStore }> {
  render() {
    const store = this.props.store;
    const classname = store.paused || store.ended
      ? 'fa fa-play'
      : 'fa fa-pause';
    return (
      <button type="button" className="btn btn-outline-primary"
              onClick={store.togglePlay}>
        <span className={classname}/>
      </button>);
  }
}

@observer
class TeacherSyncedVideoControls extends React.Component<{ store: TeacherSyncedVideoStore }> {
  render() {
    const store = this.props.store;

    return (
      <div className="row no-gutters">
        <div className="col-auto playerBlockButton">
          <TeacherPlayButton store={store.video}/>
        </div>
        <div className="col playerBlock">
          <VideoProgress className="teacher-progress" store={store.progress}
                         updateVideo={store.video}/>
          {
            Array.from(trackedStudentProgress(store))
          }
        </div>
      </div>);
  }
}

@observer
export class TeacherSyncedVideo extends React.Component<Props> {
  readonly videoRef = React.createRef<HTMLVideoElement>();

  readonly store: TeacherSyncedVideoStore;

  constructor(props: Readonly<Props>) {
    super(props);
    const model = JSON.parse(props.x9.Contents) as SyncedVideoModel;
    this.store = new TeacherSyncedVideoStore(props.x9.Id, model, props.store);
  }

  render() {
    const store = this.store;

    const handleError = () => {
      store.video.setIsVideoError(true);
    }

    return (
      <div className="teacher-synced-video">
        <video className="synced-video"
               ref={this.videoRef}
               src={store.model.videoUrl}
               controls={false}
               autoPlay={false}
               loop={false}
               preload="auto"
               onError={handleError}/>
        { store.video.isVideoError && <p className="getUrlSourceError">Video not found</p> }
        <TeacherSyncedVideoControls store={store}/>
      </div>);
  }

  componentDidMount() {
    this.store.video.setElement(this.videoRef.current!);
  }

  componentWillUnmount() {
    this.store.video.pause();
    this.store.video.setCurrentTime(0);
    this.store.video.setIsVideoError(false);
    this.store.dispose();
  }
}
